<div class="row">
  <div class="col justify-content-center align-items-center d-flex">

    <app-eca-ghost-btn [btnText]="viewBtnText" btnType="primary" style="margin-right: 5px" [removeLabelOnMobile]="removeLabelOnMobile"
                       [btnSize]="viewBtnSize"
                       (btnClicked)="viewClicked()"
                       *ngIf="viewBtnVisible">
    </app-eca-ghost-btn>

    <button type="button"
            pButton
            icon="fa fa-ellipsis-v"
            [label]="menuLabel"
            [disabled]="isDisabled"
            class="eca-row-menu"
            (click)="menu.toggle($event)"
            *ngIf="rowMenuVisible">
    </button>
    <p-menu #menu [popup]="true" [model]="menuItems" appendTo="body"></p-menu>
  </div>
</div>
